<template>
  <div class="w-full flex flex-col gap-6 justify-start">
    <div class="flex justify-between">
      <div class="text-white">
        <p class="font-bold text-2xl">//Calls</p>
        <p>Conference rooms for private calls.</p>
      </div>
    </div>

    <div class="basic_child_parent__ w-1/2 flex items-center justify-between pr-5">
      <div class="choose-room">
        <button class="options-button border-none" @click="changeFocus(true)"
          :class="{ 'focused-button': focusYourRooms }">
          /rooms
        </button>
        <button class="options-button border-none px-5" @click="handleButtonClick"
          :class="{ 'focused-button': !focusYourRooms }">
          /recordings
        </button>
      </div>

      <div class="cursor-pointer">
        <vx-tooltip text="/ Create Room" position="left">
          <img @click="$router.push('/dashboard/rooms/create')" src="@/assets/images/pixel_create.svg" />
        </vx-tooltip>
      </div>
    </div>

    <div class="flex flex-row gap-12 w-full">
      <div class="flex flex-col gap-6 w-1/2">
        <!-- <div class="choose-room">
          <button class="options-button border-none" @click="changeFocus(true)"
            :class="{ 'focused-button': focusYourRooms }">
            /rooms
          </button>
          <button class="options-button border-none px-5" @click="handleButtonClick"
            :class="{ 'focused-button': !focusYourRooms }">
            /recordings
          </button>
        </div> -->

        <div class="flex flex-col gap-4">
          <div class="room_list_cont" v-if="focusYourRooms">
            <div v-if="isRoomsLoading">
              <RoomCardShimmer />
              <RoomCardShimmer :style="{ opacity: 0.7 }" />
              <RoomCardShimmer :style="{ opacity: 0.4 }" />
            </div>
            <div v-else-if="rooms.length === 0"
              class="flex flex-row h-full items-start justify-center text-white text-left pt-6">
              <span class="text-2xl font-semibold text-white">You have not created any rooms yet.
                <br>
                Click <span class="text-primary cursor-pointer" @click="$router.push('/dashboard/rooms/create')">here</span> to get
                started and create your room
                now!</span>
            </div>
            <div v-else-if="rooms.length">
              <div v-for="(room, index) in rooms" :key="index">
                <RoomCard 
                  :getRoomList="getList" 
                  :room="room" 
                  :index="index" 
                  :roomsList="rooms"
                  :isSelected="isRoomSelected(room)"
                  @room-click="handleRoomClick" />
              </div>
            </div>
          </div>

          <div v-else class="room_list_cont">
            <div v-if="isRecordingLoading">
              <RecordingCardShimmer />
              <RecordingCardShimmer :style="{ opacity: 0.7 }" />
              <RecordingCardShimmer :style="{ opacity: 0.4 }" />
            </div>
            <div v-else-if="recordingList.length">
              <div v-for="(recording, index) in recordings" :key="index">
                <RecordingCard :recording="recording" :index="index" :getRecordings="getRecordings"
                  @recording-selected="handleRecordingSelect" @auto-rename="onAutoRename" />
              </div>
            </div>
            <div v-else class="recording flex flex-col items-center justify-items-center">
              <span>
                <svg width="160px" height="160px" viewBox="0 0 16 16" version="1.1" xmlns="http://www.w3.org/2000/svg"
                  xmlns:xlink="http://www.w3.org/1999/xlink" class="si-glyph si-glyph-disc-upload" fill="#ffffff">
                  <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                  <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
                  <g id="SVGRepo_iconCarrier">
                    <title>598</title>
                    <defs> </defs>
                    <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                      <g fill="#ffffff">
                        <path
                          d="M7.917,6 C6.857,6 6,6.863 6,7.93 C6,8.995 6.857,9.858 7.917,9.858 C8.974,9.858 9.832,8.996 9.832,7.93 C9.832,6.864 8.974,6 7.917,6 L7.917,6 Z"
                          class="si-glyph-fill"> </path>
                        <path
                          d="M10.979,15.1106614 L14.51,10.5030985 L15.2,11.4045782 C15.702,10.3553813 15.999,9.18983179 15.999,7.94637663 C15.999,3.49867206 12.417,0 7.999,0 C3.581,0 -0.00100000005,3.49867206 -0.00100000005,7.94637663 C-0.00100000005,12.3940812 3.581,16 7.999,16 C9.366,16 10.642,15.7005185 11.765,15.1106614 L10.979,15.1106614 L10.979,15.1106614 Z M12.423,2.691 L13.269,3.537 L11.481,5.324 L10.637,4.479 L12.423,2.691 L12.423,2.691 Z M3.548,13.258 L2.703,12.412 L4.49,10.625 L5.336,11.47 L3.548,13.258 L3.548,13.258 Z M8,11 C6.34408936,11 5,9.65704979 5,8.00046533 C5,6.34388087 6.34315855,5 8,5 C9.65684145,5 11,6.34295021 11,8.00046533 C11,9.65611913 9.65591064,11 8,11 L8,11 Z"
                          class="si-glyph-fill"> </path>
                        <path
                          d="M16,13.966 L14.511,12.106 L13.021,13.966 L14.018,13.966 L14.018,15.969 L14.988,15.969 L14.988,13.966 L16,13.966 Z"
                          class="si-glyph-fill"> </path>
                      </g>
                    </g>
                  </g>
                </svg>
              </span>
              <h1 class="text-lg text-white font-semibold">No Recordings Found.</h1>
            </div>
          </div>
        </div>
      </div>

      <!-- Room Details or Empty State -->
      <div v-if="firstRoomId !== null && focusYourRooms" class="room_details w-1/2 p-5">
        <RoomDetails :selectedRoomDetails="selectedRoomDetails" :firstRoomId="firstRoomId" />
      </div>
      <div v-else-if="rooms.length === 0 && focusYourRooms && !isRoomsLoading" class="room_details w-1/2 p-5">
        <div class="room_header flex justify-between items-center w-full h-16 px-4 py-2 z-5 sticky top-0">
          <p class="text-xl font-bold">/room.welcome</p>
        </div>
        
        <div class="flex flex-col items-center justify-center text-center px-6" style="min-height: calc(60vh - 10rem);">          
          <h2 class="text-xl font-bold text-white mb-3">Ready for Private Calls?</h2>
          <p class="text-base text-slate-300 mb-6 leading-relaxed max-w-sm">
            Create your first room for private conference calls with your team or clients.
          </p>
          
          <div class="w-full max-w-xs">
            <button 
              @click="$router.push('/dashboard/rooms/create')"
              class="w-full px-6 py-3 bg-primary text-black font-semibold rounded-lg hover:bg-lime-500 transition-colors duration-200">
              Create Your First Room
            </button>
          </div>
        </div>
      </div>

      <!-- Recording Details -->
      <div v-if="recordId !== undefined && !focusYourRooms" class="record_details w-1/2 p-5">
        <RoomRecordDetails ref="details" :selectedRecordId="selectedRecordId" :recordId="recordId"
          :getRecordings="getRecordings" />
      </div>
    </div>
    <CreateRoomModal v-if="activeModal === 'createRoomModal'" :closeModal="closeCreateModal" :getRoomList="getList" />
  </div>
</template>

<script>
import RoomCard from './components/RoomCard.vue';
import RoomCardShimmer from './components/RoomCardShimmer.vue';
import RecordingCard from './components/RecordingCard.vue';
import RecordingCardShimmer from './components/RecordingCardShimmer.vue';
import CreateRoomModal from '@/views/new-dashboard/rooms/components/CreateRoomModal.vue';
import RoomDetails from '@/views/new-dashboard/rooms/components/RoomDetails.vue';
import RoomRecordDetails from '@/views/new-dashboard/rooms/components/RoomRecordDetails.vue';
export default {
  name: 'RoomSection',
  components: {
    RoomCard,
    RoomCardShimmer,
    RecordingCard,
    RecordingCardShimmer,
    CreateRoomModal,
    RoomDetails,
    RoomRecordDetails,
  },
  data() {
    return {
      activeModal: '', //createRoomModal
      isRecordingLoading: false,
      focusYourRooms: true,
      rooms: [],
      isRoomsLoading: false,
      recordings: [],
      email: '',
      roomUrl: '',
      selectedRoomDetails: null,
      firstRoomId: null,
      selectedRoomId: null,
      recordId: null,
      selectedRecordId: null,
    };
  },
  computed: {
    roomsList() {
      return this.$store.state.room.rooms;
    },
    recordingList() {
      return this.$store.state.room.recordings;
    },
  },
  watch: {
    // whenever question changes, this function will run
    roomsList(newList) {
      //console.log(newList);
      this.rooms = [...newList];
      if (newList.length > 0) {
        const firstRoom = newList[0];
        const firstRoomId = firstRoom.room_url ? firstRoom.room_url.split('/').pop() : null;
        this.firstRoomId = firstRoomId;
        // Set initial selection if no room is currently selected
        if (!this.selectedRoomId) {
          this.selectedRoomId = firstRoomId;
        }
      } else {
        this.firstRoomId = null;
        this.selectedRoomId = null;
      }
      //console.log(this.firstRoomId, 'firstRoomId');
      //console.log(this.rooms);
    },
    recordingList(newList) {
      //console.log(newList);
      this.recordings = [...newList];
      //console.log(this.recordings);
    },
    '$route'(to, from) {
      if (to.params.action === 'create') {
        this.setActiveModal('createRoomModal');
      }
    }
  },
  mounted() {
    if (this.$route.params.action === 'create') {
      this.setActiveModal('createRoomModal')
    }
    this.getList();
  },
  methods: {
    closeCreateModal() {
      this.setActiveModal('');
      this.$router.push('/dashboard/rooms');
      localStorage.removeItem("LOG_BOARDID");
      localStorage.removeItem("LOG_REDIRECT");
      localStorage.removeItem("LOG_TOKEN");
    },
    handleRoomClick(details) {
      this.selectedRoomDetails = details;
      // Set the selected room ID
      this.selectedRoomId = details.id;
      //console.log(this.selectedRoomDetails, 'jfkll')
    },
    isRoomSelected(room) {
      if (!this.selectedRoomId || !room.room_url) return false;
      const roomId = room.room_url.split('/').pop();
      return roomId === this.selectedRoomId;
    },
    changeFocus(toYourRooms) {
      this.focusYourRooms = toYourRooms;
    },
    setActiveModal(modalName) {
      this.activeModal = modalName;
    },
    getList() {
      this.isRoomsLoading = true;
      this.$store
        .dispatch('room/getList')
        .then((res) => {
          //console.log(res);
          this.isRoomsLoading = false;
        })
        .catch((e) => {
          //console.log(e);
          this.isRoomsLoading = false;
        });
    },
    async getRecordings() {
      this.isRecordingLoading = true;
      try {
        const res = await this.$store.dispatch('room/getRecordings');
        this.isRecordingLoading = false;
        //console.log(res);
      } catch (e) {
        this.isRecordingLoading = false;
        console.error('Error getting recordings', e);
      }
    },
    async handleButtonClick() {
      this.changeFocus(false);
      this.isRecordingLoading = true;
      try {
        await this.getRecordings();
      } catch (e) {
        console.error('Error getting recordings', e);
      }
      this.isRecordingLoading = false;
    },
    handleRecordingSelect(recordingId) {
      this.recordId = recordingId;
      this.selectedRecordId = recordingId;
    },
    onAutoRename(rec) {
      // show the recordings pane if needed
      this.focusYourRooms = false;

      // point the details view at the clicked recording
      this.selectedRecordId = rec;
      this.recordId = rec;

      // ensure RoomRecordDetails is mounted/updated, then call the method
      this.$nextTick(() => {
        const child = this.$refs.details;
        if (child && typeof child.handleAutoRename === 'function') {
          child.handleAutoRename();
        } else {
          // if it’s still not there (edge case), try once more next tick
          this.$nextTick(() => {
            const child2 = this.$refs.details;
            if (child2 && typeof child2.handleAutoRename === 'function') {
              child2.handleAutoRename();
            }
          });
        }
      });
    }
  },
};
</script>

<style scoped>
* {
  font-family: 'JetBrains Mono', monospace !important;
}

.options-button {
  background: none;
  color: #fff;
  font-size: 16px;
  font-weight: 700;
  cursor: pointer;
}

.focused-button {
  color: #d7df23;
}

.room_details,
.record_details {
  border: 2px solid #272727;
  box-shadow: 3px 3px 0px 0px #272727;
  height: 60vh;
}

.record_details::-webkit-scrollbar {
  display: none;
}

@media screen and (max-width: 1000px) {
  .room_details {
    display: none;
  }
}


.room_header {
  background-color: #272727;
}

.room_list_cont {
  overflow: scroll !important;
  height: 64vh;
  max-width: 645px;
}

.room_list_cont::-webkit-scrollbar {
  display: none;
}
</style>